module.exports = __webpack_public_path__ + "static/bananas-aaf2aa55f8f786814fa0973e093f8caa.gif";